module.exports = __webpack_public_path__ + "static/dochq-logo-rect-white-eab4dddbc3980c26c7d41f6e7248cab0.svg";